import { Dispatch, SetStateAction, useEffect } from "react";
import { DetailView } from "../components/PageView/PageViewTable/SharedToolbar/SharedToolbar";
import { useAtom } from "jotai";
import { drawersInURLAtom } from "../atoms/GlobalAtoms";
import { useSearchParams } from "react-router-dom";

interface Props {
  setOpenRecordData: Dispatch<SetStateAction<DetailView>>;
  viewID?: string;
}

const useViewRecordURL = ({ setOpenRecordData, viewID }: Props) => {
  const [search] = useSearchParams();
  const [drawersInURL, setDrawersInURL] = useAtom(drawersInURLAtom);

  /**
   * Check if any records are open when reloading the page, and when search updates
   * ViewRecordDrawer Opening can only occur on first render. Closing can occur whenever search updates.
   */
  useEffect(() => {
    if (!viewID) return;

    const drawers = search.get("open"); // Get the opened drawers data from the URL

    let drawersObject = [];

    if (drawers) {
      try {
        const parsed = JSON.parse(drawers);

        if (parsed?.length) {
          drawersObject = parsed;
        }
      } catch (e) {}
    }

    // Open ViewRecordDrawer if drawer data exists
    if (drawersObject?.length) {
      const foundDrawersObject = drawersObject.find(
        (d: any) => d?.vID === viewID
      );

      const recordID = foundDrawersObject?.id;
      const moduleAPIName = foundDrawersObject?.module?.APIName;
      const tab = foundDrawersObject?.tab ?? "Summary";

      // Don't open if it is not the first render.
      if (recordID && moduleAPIName) {
        // Drawer has already been opened.
        if (drawersInURL.includes(viewID)) return;

        setDrawersInURL((prev) => [...prev, viewID]);
        setOpenRecordData((prev) =>
          !prev ? { recordID, moduleAPIName, tab, viewID } : null
        );
      }
    } else {
      setDrawersInURL([]);
      setOpenRecordData(null);
    }
  }, [search, viewID]);
};

export default useViewRecordURL;
